import Choices from "choices.js";
import { chosenItemTemplate } from "./templates/choices";
import state from "../state";

state.channel.subscribe("onCountryRemoved", countryId => {
  state.countryLabels.remove(countryId);
});

class FilterNavView {
  constructor() {
    this.dom = document.querySelector("#filter-nav");

    // Used to disambiguate sector and intervention selections
    this.categoryPrefixes = new Map();

    // Initialize the select UI when the data arrives
    state.channel.subscribe("onGraphLoaded", graph => {
      this.initializeCountriesSelect(graph.countries());
      this.initializeCategoriesSelect(graph.sectors(), graph.interventions(), graph.categories());
    });

    // this.dom.addEventListener("mouseenter", (ev) => {
    //   console.log("FilterNavView")
    //   ev.target.focus();
    // });
  }

  // The countries select provides a keyword search index over the list of
  // countries. State and other high level toggles TBD.
  initializeCountriesSelect(countries) {
    const element = this.dom.querySelector("#countries");

    this.countriesSelect = new Choices(element, {
      maxItemCount: 6,
      duplicateItemsAllowed: false,
      removeItemButton: true,
      choices: countries.map(c => ({
        value: c.id,
        label: c.props.name,
        selected: false,
        disabled: false
      })),
      callbackOnCreateTemplates: () => ({
        item: chosenItemTemplate
      })
    });

    element.addEventListener("addItem", payload => {
      state.channel.publish("onCountrySelected", {
        id: payload.detail.value,
        name: payload.detail.label
      });
    });

    element.addEventListener("removeItem", payload => {
      state.channel.publish("onCountryRemoved", payload.detail.value);
    });
  }

  // The categories select provides a keyword search index over the combined
  // lists of interventions and sectors. Instead of doing a union of these
  // two lists, they are set as separate groups of choices with descriptive
  // labels. This doesn’t change the interaction with multiple choices which
  // still remains a flat list.
  //
  // Because these groups aren't distinguished in the interaction, we store
  // an event prefix on each item to represent which group it belongs to.
  initializeCategoriesSelect(sectors, interventions, categories) {
    const element = this.dom.querySelector("#categories");

    this.categoriesSelect = new Choices(element, {
      duplicateItemsAllowed: false,
      removeItemButton: true,
      choices: [
        {
          label: "Type of Intervention",
          id: "intervention",
          choices: interventions.map(i => ({
            value: i.id,
            label: i.name,
            selected: false,
            disabled: false,
            customProperties: { type: "onIntervention" }
          }))
        },
        {
          label: "Sector",
          id: "sector",
          choices: sectors.map(s => ({
            value: s.id,
            label: s.name,
            selected: false,
            disabled: false,
            customProperties: { type: "onSector" }
          }))
        },
        {
          label: "Category",
          id: "category",
          choices: categories.map(ct => ({
            value: ct.id,
            label: ct.name,
            selected: false,
            disabled: false,
            customProperties: { type: "onCategory" }
          }))
        }
      ]
    });

    // Wraps the UI interaction for selecting an item and broadcasts it to the
    // event channel based on the prefix mapped to the item (either onSector or
    // onIntervention or onCategory).
    //
    // We also store the selected item in a local lookup table so we can
    // reference this mapping when it gets removed.
    element.addEventListener("addItem", payload => {
      const eventType = payload.detail.customProperties.type;
      this.categoryPrefixes.set(payload.detail.value, eventType);

      state.channel.publish(`${eventType}Selected`, {
        id: payload.detail.value,
        name: payload.detail.label,
      });
    });

    // Wraps the UI interaction for removing a selected item and broadcasts it
    // to the event channel.
    element.addEventListener("removeItem", payload => {
      const eventType = this.categoryPrefixes.get(payload.detail.value);
      this.categoryPrefixes.delete(payload.detail.value);
      state.channel.publish(`${eventType}Removed`, payload.detail.value);
    });
  }
}

export default FilterNavView;
